/**
 * Тур по странице заявок та підтримки (Requests).
 * Знайомить користувача з сервісними заявками та чатом підтримки.
 * ВАЖНО: Тур працює тільки на великих екранах (>= 769px).
 */
export default {
  id: 'requests-page',
  name: 'help.tours.requests.name',
  description: 'help.tours.requests.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Крок 1: Привітання
    {
      element: '.page-title',
      titleKey: 'help.tours.requests.welcome.title',
      descriptionKey: 'help.tours.requests.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Крок 2: Кнопка нової заявки
    {
      element: '.btn.btn--primary',
      titleKey: 'help.tours.requests.newRequest.title',
      descriptionKey: 'help.tours.requests.newRequest.description',
      side: 'bottom',
      align: 'end',
    },
    // Крок 3: Фільтр по статусу (активні / виконані)
    {
      element: '.stats-row',
      titleKey: 'help.tours.requests.filter.title',
      descriptionKey: 'help.tours.requests.filter.description',
      side: 'bottom',
      align: 'start',
    },
    // Крок 4: Список заявок
    {
      element: '.requests-list',
      titleKey: 'help.tours.requests.list.title',
      descriptionKey: 'help.tours.requests.list.description',
      side: 'top',
      align: 'center',
    },
    // Крок 5: Картка заявки
    {
      element: '.request-card',
      titleKey: 'help.tours.requests.card.title',
      descriptionKey: 'help.tours.requests.card.description',
      side: 'left',
      align: 'center',
    },
    // Крок 6: Секція чату підтримки
    {
      element: '.support-section',
      titleKey: 'help.tours.requests.support.title',
      descriptionKey: 'help.tours.requests.support.description',
      side: 'top',
      align: 'center',
    },
  ],
}
